import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import { onModuleClick } from 'owa-workloads';
import type * as lazyIndex from './lazyIndex';
import type { CopilotAccountPickerInlineProps } from './components/CopilotAccountPickerInline';
import type { CopilotAccountSwitcherProps } from './components/CopilotAccountSwitcher';

// Create lazy module for components
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotAccountPicker" */ './lazyIndex'),
    { name: 'CopilotAccountPicker' }
);

// Lazy-loaded components
export const CopilotAccountPickerInline: LazyComponent<
    CopilotAccountPickerInlineProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotAccountPickerInline);

export const CopilotAccountSwitcher: LazyComponent<CopilotAccountSwitcherProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotAccountSwitcher);

// Re-export types (types don't add to bundle size)
export type { CopilotAccountPickerInlineProps } from './components/CopilotAccountPickerInline';
export type { CopilotAccountSwitcherProps } from './components/CopilotAccountSwitcher';

// External API - only exports needed by consumers (CopilotChatDrawer)
export { getCurrentAccount } from './selectors/getCurrentAccount';
export { resetCopilotAccountPickerDialogStoreMutator } from './mutators/accountPickerMutators';

// Register lazy orchestrator
registerLazyOrchestrator(onModuleClick, lazyModule, m => m.resetStoreOnModuleChangeOrchestrator);
